import {
  ChangeDetectorRef,
  Component,
  Input,
  InputSignal,
  forwardRef,
  inject,
  input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from "@angular/forms";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-input",
  templateUrl: "./input.component.html",
  styleUrl: "./input.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, SvgIconComponent],
})
export class InputComponent implements ControlValueAccessor {
  public readonly type: InputSignal<HTMLInputElement["type"]> =
    input<HTMLInputElement["type"]>("text");
  public readonly id: InputSignal<string> = input<string>("");
  public readonly name: InputSignal<string> = input<string>("");
  // Stays a decorator input: written by ngModel / writeValue (NB58, plan 00-foundation-a step 6).
  @Input() public value: string = "";
  public readonly placeholder: InputSignal<string> = input<string>("");
  public readonly label: InputSignal<string> = input<string>("");
  public readonly error: InputSignal<string> = input<string>("");
  // Stays a decorator input: written by setDisabledState (NB58, plan 00-foundation-a step 6).
  @Input() public disabled: boolean = false;
  public readonly required: InputSignal<boolean> = input<boolean>(false);
  public readonly readonly: InputSignal<boolean> = input<boolean>(false);
  public readonly lightInput: InputSignal<boolean> = input<boolean>(false);
  public readonly autoComplete: InputSignal<string> = input<string>("off");
  public readonly max: InputSignal<number | undefined> = input<number | undefined>();
  public readonly icon: InputSignal<string> = input<string>("");

  public onChange: (value: unknown) => unknown = (value: unknown): unknown => value;
  // eslint-disable-next-line no-empty-function
  public onTouched: () => void = (): void => {};

  private readonly _cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  public writeValue(obj: unknown): void {
    this.value = obj as string;
    this._cdr.markForCheck();
  }

  public registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
